"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecQuantityChange = void 0;
const enums_1 = require("../enums");
const pushToDataLayer_1 = require("./pushToDataLayer");
const buildEecProduct_1 = require("./buildEecProduct");
const clearGA4EventData_1 = require("./clearGA4EventData");
const buildGA4ProductDetail_1 = require("./buildGA4ProductDetail");
const getVariant_1 = require("../helper/getVariant");
const mapCartProductToProduct_1 = require("../helper/mapCartProductToProduct");
function trackEecQuantityChange({ cart, changedItem, quantityDifference, product, variant, appointment, itemListName, }) {
    const { currencyCode } = cart.total.gross;
    (0, clearGA4EventData_1.clearGA4EventData)();
    const isAddToCartEvent = quantityDifference > 0;
    const eventName = isAddToCartEvent ? enums_1.GA4EventName.AddToCart : enums_1.GA4EventName.RemoveFromCart;
    const quantity = Math.abs(quantityDifference);
    const newChangedItemQuantity = changedItem.quantity + quantityDifference;
    const eventData = (0, buildGA4ProductDetail_1.buildGA4ProductDetailInteraction)({
        eventName,
        featureCategory: enums_1.GA4FeatureCategory.Ecommerce,
        itemListName,
        product: (0, mapCartProductToProduct_1.mapCartProductToProduct)(product),
        variant: variant || (0, getVariant_1.getVariant)(appointment, product.productType),
        quantity,
    });
    const payload = {
        products: [
            (0, buildEecProduct_1.buildEecProduct)({
                quantity,
                product: changedItem.product,
                appointment: changedItem.appointment,
            }),
        ],
    };
    const quantityOfUnchangedItems = cart.items
        .filter(cartItem => cartItem.id !== changedItem.id)
        .reduce((count, cartItem) => cartItem.quantity + count, 0);
    const cartItemCount = newChangedItemQuantity + quantityOfUnchangedItems;
    (0, pushToDataLayer_1.pushToDataLayer)(isAddToCartEvent
        ? {
            event: enums_1.EventName.EECAddToCart,
            ecommerce: {
                currencyCode,
                add: payload,
            },
            ...eventData,
        }
        : {
            event: enums_1.EventName.EECRemoveFromCart,
            cart_item_count: cartItemCount,
            ecommerce: {
                currencyCode,
                remove: payload,
            },
            ...eventData,
        });
}
exports.trackEecQuantityChange = trackEecQuantityChange;
//# sourceMappingURL=trackEecQuantityChange.js.map